<template>
  <nav
    class="legal-footer-links"
    aria-label="Yasal bilgilendirme bağlantıları"
  >
    <b-link :to="{ name: 'legal-hub' }">
      Bilgilendirme Metinleri'ne ulaşmak için tıklayınız
    </b-link>
  </nav>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  name: 'LegalFooterLinks',
  components: {
    BLink,
  },
}
</script>

<style scoped>
.legal-footer-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}

@media (max-width: 767.98px) {
  .legal-footer-links {
    justify-content: flex-start;
    margin-top: 0.75rem;
  }
}
</style>
